const styles = {
  footer__container: {
    position: 'absolute',
    bottom: 0,
    flexDirection: 'column',
    display: 'flex',
    width: '100%',
  },

  divider: {
    paddingLeft: '2em',
    paddingRight: '2em',
  },
};

export default styles;
